import axios from 'axios';
import qs from 'querystring';

export const salesforceAuthClient = axios.create({
  baseURL: 'https://login.salesforce.com',
  timeout: 30 * 1000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  transformRequest: [(data) => qs.stringify(data)],
});
